import { MaxButton } from 'pages/Pool/styleds'
import { Text } from 'rebass'
import styled from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
  /* padding: 20px; */
  /* min-width: 460px; */
  width: 100%;

  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    min-width: 340px;
  `};
`

export const SmallMaxButton = styled(MaxButton)`
  font-size: 12px;
  margin: 0 !important;
`

export const ResponsiveHeaderText = styled(Text)`
  font-size: 24px;
  font-weight: 500;
  width: 2rem;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
     font-size: 24px;
  `};
`
